import React, { Component } from 'react'
import FileInput from './FileInput'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import Comment from './Comment'
import Skeleton from '../UI/Skeleton'

const HomeWorkWrapper = styled.div`
    .title {
        font-family: Open Sans;
        font-weight: 600;
        padding-top: 40px;
    }
    .description {
        font-family: Open Sans;
        padding-top: 20px;
        color: #484848;
    }
`

class HomeWork extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <React.Fragment>
                            <div className='d-flex justify-content-between mt-4 w-100'>
                                <Skeleton width={150} className="lg-font-size" />
                                <Skeleton width={100} className="md-font-size" />
                            </div>
                            <Skeleton height={100} className="mb-3" />
                        </React.Fragment>
                        :
                        <HomeWorkWrapper>
                            {
                                this.props.taskStatus.comments.map(({ id, from, createdAt, comment, files }) => (
                                    <Comment
                                        key={id}
                                        from={from}
                                        date={createdAt}
                                        comment={comment}
                                        files={files}
                                    />
                                ))
                            }
                            <div className={this.props.description ? "description md-font-size" : ""} dangerouslySetInnerHTML={{ __html: this.props.description }}></div>
                            <FileInput
                                courseId={this.props.courseId}
                                modId={this.props.modId}
                                status={this.props.taskStatus.status}
                                updateHomework={this.props.updateHomework}
                                title={this.props.title}
                                localId={this.props.localId}
                            />
                        </HomeWorkWrapper>
                }
            </React.Fragment>
        )
    }
}

HomeWork.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    courseId: PropTypes.string,
    modId: PropTypes.string,
    taskStatus: PropTypes.object,
    updateHomework: PropTypes.func,
    description: PropTypes.string,
    skeleton: PropTypes.bool,
    title: PropTypes.string,
    localId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
}


export default withTranslation()(HomeWork)


// WEBPACK FOOTER //
// ./src/components/Study/HomeWork.jsx